import type { BarSeriesOption } from 'echarts';

export const BAR_LABEL_FONT_SIZE = 11;
const LABEL_PADDING = 2;

// ECharts reruns label layout after zoom, legend changes, and chart resizing.
export const fitBarLabel: NonNullable<BarSeriesOption['labelLayout']> = ({
  rect,
  labelRect
}) => {
  const fits =
    Math.abs(rect.height) >= labelRect.height + LABEL_PADDING * 2 &&
    Math.abs(rect.width) >= labelRect.width + LABEL_PADDING * 2;

  // Labels use overflow: 'truncate' and ellipsis: '' so zero width hides the
  // entire value rather than displaying a misleading partial number.
  return fits ? {} : { width: 0 };
};
